import React from "react";

import AiAssistant from "../../aiAssistant/AiAssistant";
import { useAiAssistant } from "../../../../_theme/context/AiAssistantContext";
import { KTIcon } from "../../../../_theme/helpers";
import { MessageCircle } from "lucide-react";


const AIAssistantSidebar: React.FC = () => {
    const { isOpen, toggleAssistant } = useAiAssistant();

    const sidebarWidth = isOpen
        ? "w-xl-300px w-xxl-350px w-100"
        : "w-50px";

    return (
        <div
            className={`position-relative d-flex overflow-visible flex-row-auto h-100 ${sidebarWidth} ms-5`}
        >
            <div className="w-100 h-100 d-flex flex-column">
                <div className="ai-assistant hide-steps-btn w-fit-content flex-shrink-0">
                    <button
                        onClick={toggleAssistant}
                        type="button"
                        aria-label={isOpen ? "Collapse AI Assistant" : "Expand AI Assistant"}
                        aria-expanded={isOpen}
                        className="btn btn-sm btn-light-primary mb-3 p-2"
                    >
                        <KTIcon
                            iconName={isOpen ? "left" : "right"}
                            className="fs-3 m-0"
                        />
                    </button>
                </div>

                <div className="flex-grow-1 min-h-0">
                    {!isOpen ? (
                        <div
                            className="card bg-ai-header w-100 h-100 d-flex justify-content-center align-items-center"
                            style={{ minHeight: "90vh" }}
                        >
                            <div
                                className="d-flex align-items-center text-white fw-bold"
                                style={{
                                    writingMode: "vertical-rl",
                                    textOrientation: "mixed",
                                    fontSize: "1.25rem",
                                    gap: "0.5rem",
                                }}
                            >
                                <MessageCircle size={20} />
                                <span>AI Assistant</span>
                            </div>
                        </div>
                    ) : (
                        <AiAssistant />
                    )}
                </div>
            </div>
        </div>
    );
};

export default React.memo(AIAssistantSidebar);